module.exports = __webpack_public_path__ + "img/undTooth9.3354a8a5.png";